import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCities } from "../lib/api";
import { Logo } from "./Navbar";

const DEFAULT_CITIES = ["Dodoma", "Mwanza", "Arusha", "Mbeya", "Tabora"];

const FooterLink = ({ to, href, children }) => (
  <li>
    {href
      ? <a href={href} className="inline-block py-1 text-sm text-white/70 transition-colors hover:text-hs-amber">{children}</a>
      : <Link to={to} className="inline-block py-1 text-sm text-white/70 transition-colors hover:text-hs-amber">{children}</Link>}
  </li>
);

const Footer = () => {
  const [cities, setCities] = useState(DEFAULT_CITIES);

  useEffect(() => {
    let active = true;
    getCities()
      .then(list => {
        const top = list.filter(c => c.hotel_count > 0).sort((a, b) => b.hotel_count - a.hotel_count).slice(0, 5).map(c => c.city);
        if (active && top.length) setCities(top);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    // Extra bottom padding on mobile clears the fixed bottom navigation.
    <footer className="bg-hs-charcoal px-4 pb-28 pt-12 text-white md:pb-12">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo light />
            <p className="mt-2 text-sm text-white/60">Tanzania's hotel directory</p>
          </div>
          <div>
            <h4 className="section-label mb-3 text-white/50">Browse</h4>
            <ul>
              <FooterLink to="/hotels">All Hotels</FooterLink>
              <FooterLink to="/#cities">By City</FooterLink>
              <FooterLink to="/hotels?sort=price_asc">By Budget</FooterLink>
            </ul>
          </div>
          <div>
            <h4 className="section-label mb-3 text-white/50">Cities</h4>
            <ul>
              {cities.map(city => <FooterLink key={city} to={`/hotels?city=${encodeURIComponent(city)}`}>{city}</FooterLink>)}
            </ul>
          </div>
          <div>
            <h4 className="section-label mb-3 text-white/50">Habari Stays</h4>
            <ul>
              <FooterLink to="/#how-it-works">About</FooterLink>
              <FooterLink href="mailto:info@habaristays.com">Contact</FooterLink>
              <FooterLink to="/register-hotel">List Your Hotel</FooterLink>
            </ul>
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} Habari Stays. All rights reserved.</span>
          <span>Made in Tanzania 🇹🇿</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
